import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './resources.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Resource extends React.Component{
	constructor (props) {
		super(props)
		this.state={

		}
	}
    componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
    }
	render() {
		return(
			<div className="resource-child">
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/resource' className="mianbaoxie">流量资源</a> <i className='glyphicon glyphicon-toright'></i> <span>搜索引擎广告</span>
				</div>
				<div className='common-title minWith' style={{marginBottom: '24px'}}>什么是搜索引擎广告？</div>
				<div className='text-center minWith'>搜索引擎广告终端载体有PC和手机端，包括关键词广告、竞价排名广告、地址栏搜索广告和网站登录广告等形式。</div>
				<div className='text-title text-center minWith'>您的广告可以展示在这里</div>
				<div className='home-contain' style={{paddingBottom: '35px'}}>
					<div className='home-contain text-contain'>
						<span className='second-title'></span>
						<div className='text-center'>
							<div style={{marginBottom: '30px', padding: '0 217px'}}>
								<div className='pc-img--group pull-left' style={{width: '343px', height: '226px', marginBottom: '22px'}}>
									<img src={`${process.env.PUBLIC_URL}/images/pc-border2.png`} width='343' style={{position: 'absolute', left: '0', top: '0'}}/>
									<img src={`${process.env.PUBLIC_URL}/images/ss-2.png`} style={{position: 'absolute', left: '7px', top: '8px'}}/>
								</div>
								<div className='mobile-img--group pull-right' style={{marginLeft: '70px', height: '226px', marginBottom: '22px'}}>
									<img src={`${process.env.PUBLIC_URL}/images/mobile-border3.png`} width='100' style={{position: 'absolute', left: '0', top: '0'}}/>
									<img src={`${process.env.PUBLIC_URL}/images/ss-1.png`} width='90' style={{position: 'absolute', left: '5px', top: '18px'}}/>
								</div>
								<div className='text-center'>
									品牌广告
								</div>
							</div>
							<div style={{marginBottom: '20px', padding: '0 160px'}}>
								<div className='pc-img--group pull-left' style={{width: '627px', height: '360px', marginBottom: '22px'}}>
									<img src={`${process.env.PUBLIC_URL}/images/pc-border.png`} width='627' style={{position: 'absolute', left: '0', top: '0'}}/>
									<img src={`${process.env.PUBLIC_URL}/images/ss-3.png`} style={{position: 'absolute', left: '130px', top: '57px'}}/>
								</div>
								<div className='text-center'>
									导航广告
								</div>
							</div>
						</div>
					</div>
				</div>
			</div></div>
		)
	}
}
export default Resource;



// WEBPACK FOOTER //
// ./src/components/resources/ssbanner.jsx